import { OrderStatus } from "../types/order";

export const ORDER_WORKFLOW_STEP_KEYS = [
  OrderStatus.OPEN,
  OrderStatus.READY_FOR_REVIEW,
  OrderStatus.IN_REVIEW,
  OrderStatus.REVISION_REQUIRED,
  OrderStatus.VERIFIED,
  OrderStatus.APPROVED,
] as const;

export const TRIP_ORDER_DETAIL_STEP_KEYS = [
  ...ORDER_WORKFLOW_STEP_KEYS,
  "surat_jalan_review",
  "invoicing_review",
  OrderStatus.COMPLETED,
] as const;

const APPROVED_REPORT_STATUSES = new Set(["approved", "approved_with_override"]);

/** Map order status onto the linear workflow stepper key. */
export const getOrderWorkflowStepKey = (status: OrderStatus | string): string => {
  if (status === OrderStatus.APPROVED_WITH_OVERRIDE || status === OrderStatus.COMPLETED) {
    return OrderStatus.APPROVED;
  }
  return status;
};

export const shouldShowSuratJalanSteps = (order: {
  status: OrderStatus | string;
  suratJalan?: { status: string } | null;
  uangJalanReportStatus?: string | null;
}): boolean => {
  const approvedClass =
    order.status === OrderStatus.APPROVED ||
    order.status === OrderStatus.APPROVED_WITH_OVERRIDE ||
    order.status === OrderStatus.COMPLETED;
  const reportApproved = APPROVED_REPORT_STATUSES.has(order.uangJalanReportStatus ?? "");
  return !(approvedClass && !order.suratJalan && reportApproved);
};

export const getTripOrderDetailStepKey = (order: {
  status: OrderStatus | string;
  suratJalan?: { status: string } | null;
}): string => {
  if (order.status === OrderStatus.COMPLETED) {
    return OrderStatus.COMPLETED;
  }
  if (
    order.status !== OrderStatus.APPROVED &&
    order.status !== OrderStatus.APPROVED_WITH_OVERRIDE
  ) {
    return getOrderWorkflowStepKey(order.status);
  }
  if (order.suratJalan?.status === "in_review") {
    return "surat_jalan_review";
  }
  if (order.suratJalan?.status === "invoicing_review") {
    return "invoicing_review";
  }
  return OrderStatus.APPROVED;
};

/** Workflow progress for order status (0–100). */
export const getOrderStatusProgress = (status: OrderStatus | string): number => {
  switch (status) {
    case OrderStatus.OPEN:
      return 0;
    case OrderStatus.READY_FOR_REVIEW:
      return 20;
    case OrderStatus.REVISION_REQUIRED:
      return 28;
    case OrderStatus.IN_REVIEW:
      return 45;
    case OrderStatus.VERIFIED:
      return 70;
    case OrderStatus.APPROVED:
    case OrderStatus.APPROVED_WITH_OVERRIDE:
    case OrderStatus.COMPLETED:
      return 100;
    default:
      return 0;
  }
};
